export default [

  {
    path: '/:projectId',
    component: () => import('@/views/observability/Observability.vue'),
    noAnimation: true,
    children: [
      // Healthchecks
      {
        path: 'healthchecks',
        component: () => import('@/views/observability/health-check/Healthchecks.vue'),
        name: 'healthchecks',
        meta: {
          projectRequired: true,
          pageTitle: 'Healthchecks',
          rule: 'admin',
          breadcrumb: [
            { text: 'Observability', disabled: true },
            { text: 'Healthchecks', active: true },
          ],
          navActiveLink: 'healthchecks',
        },
      },
      {
        path: 'healthcheck-groups',
        component: () => import('@/views/observability/healthcheck-groups/HealthcheckGroups.vue'),
        name: 'healthcheck-groups',
        meta: {
          projectRequired: true,
          pageTitle: 'Healthcheck Groups',
          rule: 'admin',
          breadcrumb: [
            { text: 'Observability', disabled: true },
            { text: 'Healthcheck Groups', active: true },
          ],
          navActiveLink: 'healthchecks',
        },
      },
      // Alerts
      {
        path: 'alerts',
        component: () => import('@/views/observability/alerts/Alerts.vue'),
        name: 'alerts',
        meta: {
          projectRequired: true,
          pageTitle: 'Alerts',
          rule: 'admin',
          breadcrumb: [
            { text: 'Observability', disabled: true },
            { text: 'Alerts', active: true },
          ],
          navActiveLink: 'alerts',
        },
      },
      // Providers
      {
        path: 'providers',
        component: () => import('@/views/observability/providers/Providers.vue'),
        name: 'providers',
        meta: {
          projectRequired: true,
          pageTitle: 'Providers',
          rule: 'admin',
          breadcrumb: [
            { text: 'Observability', disabled: true },
            { text: 'Providers', active: true },
          ],
          navActiveLink: 'providers',
        },
      },

    ],
  },
  // Monitoring
  {
    path: '/:projectId/monitoring/:id',
    component: () => import('@/views/observability/monitoring/details/Details.vue'),
    name: 'host-details',
    meta: {
      projectRequired: true,
      pageTitle: 'Host Details',
      rule: 'admin',
      breadcrumb: [
        { text: 'Observability', disabled: true },
        { text: 'Monitoring', to: { name: 'monitoring' } },
        { text: 'Host Details', active: true },
      ],
      navActiveLink: 'monitoring',
    },
  },

  // Healthchecks
  {
    path: '/:projectId/healthchecks/create',
    component: () => import('@/views/observability/health-check/create/Create.vue'),
    name: 'healthchecks-create',
    meta: {
      projectRequired: true,
      pageTitle: 'Create Healthcheck',
      parent: 'observability',
      rule: 'admin',
      breadcrumb: [
        { text: 'Observability', disabled: true },
        { text: 'Healthchecks', to: { name: 'healthchecks' } },
        { text: 'Create Healthcheck', active: true },
      ],
      navActiveLink: 'healthchecks',
      redirectTo: 'healthchecks',
    },
  },
  {
    path: '/:projectId/healthchecks/clone/:healthcheckId',
    component: () => import('@/views/observability/health-check/create/Clone.vue'),
    name: 'healthchecks-clone',
    meta: {
      projectRequired: true,
      pageTitle: 'Clone Healthcheck',
      parent: 'observability',
      rule: 'admin',
      breadcrumb: [
        { text: 'Observability', disabled: true },
        { text: 'Healthchecks', to: { name: 'healthchecks' } },
        { text: 'Clone Healthcheck', active: true },
      ],
      navActiveLink: 'healthchecks',
      redirectTo: 'healthchecks',
    },
  },
  {
    path: '/:projectId/healthchecks/details/:healthcheckId',
    component: () => import('@/views/observability/health-check/details/HealthcheckDetails.vue'),
    name: 'healthchecks-details',
    meta: {
      projectRequired: true,
      pageTitle: 'Healthcheck Details',
      parent: 'observability',
      rule: 'admin',
      breadcrumb: [
        { text: 'Observability', disabled: true },
        { text: 'Healthchecks', to: { name: 'healthchecks' } },
        { text: 'Healthcheck Details', disabled: true },
      ],
      navActiveLink: 'healthchecks',
      redirectTo: 'healthchecks',
    },
  },
  {
    path: '/:projectId/healthchecks/edit/:healthcheckId',
    component: () => import('@/views/observability/health-check/edit/Edit.vue'),
    name: 'healthchecks-edit',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Healthcheck',
      parent: 'observability',
      rule: 'admin',
      breadcrumb: [
        { text: 'Observability', disabled: true },
        { text: 'Healthchecks', to: { name: 'healthchecks' } },
        { text: 'Healthcheck Details', to: { name: 'healthchecks-details' } },
        { text: 'Edit Healthcheck', disabled: true },
      ],
      navActiveLink: 'healthchecks',
      redirectTo: 'healthchecks',
    },
  },
]
